/* eslint-disable max-len */
'use strict';

// Invoice Review criteria page (pages/billing_email_invoices.cfm).
// Booted by js/app/pages/billing_email_invoices.js with values from the form's data attributes.

export function init(config = {}) {

    var cfg = $.extend({
        formID: 'frmInvoiceReprint',
        initBillingDate: '',
        initBatchNo: '',
        initMode: 'batch',
        initInvoiceType: 'keep',
        nominationAccess: false,
        userDateFormat: '',
        maxReprintCount: 0,
        useBlobPrintReports: true,
        zipInvoicesByOwner: false,
        birthDayRangeStart: 0,
        birthDayRangeEnd: 0,
    }, config);
    var txt = getText();
    var formObj = $('#' + cfg.formID);
    var $go = formObj.find('.js-go');
    var $batchSelect = $('#InvoiceBatch_ID');
    var $dateSelect = $('#InvoiceDate_ID');
    var $summary = formObj.find('.js-summary');

    var currentMode = cfg.initMode;
    var currentType = (cfg.nominationAccess && cfg.initInvoiceType === 'nomination') ? 'nomination' : 'keep';
    var countTimer = null;
    var countSeq = 0;
    var lastCheck = null;
    var busy = false;
    var goBlocked = true;
    var batchesLoading = true;
    var batchSeq = 0;

    load_date_picker(cfg.birthDayRangeStart, cfg.birthDayRangeEnd, cfg.userDateFormat);

    ////////////////////
    //  Helpers
    ////////////////////

    function lowerKeys(obj){
        var out = {};
        if (obj && typeof obj === 'object'){
            $.each(obj, (key, value) =>{
                out[String(key).toLowerCase()] = value;
            });
        }
        return out;
    }

    function escapeHtml(value){
        return String(value === null || value === undefined ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function formatSqlDateForDisplay(sqlDate){
        if (!sqlDate){
            return '';
        }
        try {
            return $.datepicker.formatDate(cfg.userDateFormat, $.datepicker.parseDate('yy-mm-dd', sqlDate));
        } catch {
            return sqlDate;
        }
    }

    function selectedOutput(){
        return formObj.find('[name="invoiceOutput"]:checked').val() || 'pdf';
    }

    function isNomination(){
        return currentType === 'nomination';
    }

    // Nomination invoices always belong to billing centre 1
    function billingCentreSelector(){
        return isNomination() ? '#nominationBillingCentreID' : '#BillingCentreID';
    }

    function billingCentreID(){
        return $(billingCentreSelector()).val();
    }

    function hasInvoiceNo(value){
        return value !== null && value !== undefined && String(value).length > 0;
    }

    function invoiceRangeText(start, end){
        if (!hasInvoiceNo(start)){
            return '';
        }
        return (hasInvoiceNo(end) && String(end) !== String(start)) ? start + '-' + end : String(start);
    }

    function setButtonLabel(label){
        if ($go.data('button')){
            $go.button('option', 'label', label);
        } else {
            $go.text(label);
        }
    }

    function refreshGoState(){
        var disabled = busy || goBlocked;
        if (disabled){
            $go.attr('disabled', 'disabled');
        } else {
            $go.removeAttr('disabled');
        }
        if ($go.data('button')){
            $go.button(disabled ? 'disable' : 'enable');
        }
    }

    ////////////////////
    //  Mode
    ////////////////////

    function setMode(mode, remember){
        currentMode = (mode === 'filters') ? 'filters' : 'batch';
        $('#filterMode').val(currentMode);

        formObj.find('.js-mode').each(function(){
            var isActive = $(this).attr('data-mode') === currentMode;
            $(this).toggleClass('is-active', isActive).attr('aria-pressed', isActive ? 'true' : 'false');
        });

        formObj.find('.js-panel').each(function(){
            var $panel = $(this);
            var $inputs = $panel.find('input, select, button');
            if ($panel.attr('data-mode') === currentMode){
                $panel.customShow();
                $inputs.removeAttr('disabled');
            } else {
                $panel.customHide();
                $inputs.attr('disabled', 'disabled');
            }
        });

        if (currentMode === 'batch' && $batchSelect.find('option[value!=""]').length < 1){
            $batchSelect.attr('disabled', 'disabled');
        }

        formObj.find('.js-modeHint').text(currentMode === 'batch' ? txt.modeHintBatch : txt.modeHintFilters);

        if (remember){
            setMiscSetting('invoiceReview_filterMode', currentMode, false, true);
        }

        scheduleCount();
    }

    ////////////////////
    //  Invoice type
    ////////////////////

    function applyInvoiceType(){
        var reportName = isNomination() ? 'report_stallion_reprint_invoices' : 'billing_invoice_reprint';

        $('#invoiceType').val(currentType);
        $('#reportname').val(reportName);
        $('#report').val(reportName);
        formObj.attr('action', isNomination() ? 'pages/report_stallion_main.cfm' : 'pages/report_generic.cfm');

        formObj.find('.js-invoiceType').each(function(){
            if ($(this).val() === currentType){
                $(this).attr('checked', 'checked');
            } else {
                $(this).removeAttr('checked');
            }
        });

        formObj.find('.js-billingCentreItem').toggleClass('is-reserved', isNomination());
        $('.js-nominationTag').toggleClass('hide', !isNomination());
    }

    function setInvoiceType(type, remember){
        currentType = (cfg.nominationAccess && type === 'nomination') ? 'nomination' : 'keep';
        applyInvoiceType();

        if (remember){
            setMiscSetting('invoiceReview_invoiceType', currentType, false, true);
        }

        lastCheck = null;
        loadStats();
        loadRecentBatches();
        populateDates('', '');
    }

    ////////////////////
    //  Output
    ////////////////////

    function refreshOutput(){
        var output = selectedOutput();
        formObj.find('.ir-pill').each(function(){
            $(this).toggleClass('is-active', $(this).find('input').is(':checked'));
        });

        var desc = txt.outputPdf;
        var label = txt.buttonPdf;
        if (output === 'email'){
            desc = txt.outputEmail;
            label = txt.buttonEmail;
        } else if (output === 'zip'){
            desc = cfg.zipInvoicesByOwner ? txt.outputZipByOwner : txt.outputZip;
            label = txt.buttonZip;
        }
        formObj.find('.js-outputDesc').text(desc);
        setButtonLabel(label);
    }

    ////////////////////
    //  Billing dates and batches
    ////////////////////

    function populateDates(initDate, initBatchNo){
        batchesLoading = true;
        $('#InvoiceDate_ID_spinner').customShow();
        var dateSeq = ++batchSeq;
        EQLAPP.BILLING.populateBillingDates(billingCentreSelector(), '#InvoiceDate_ID', () =>{
            if (dateSeq !== batchSeq){
                return;
            }
            $('#InvoiceDate_ID_spinner').customHide();

            if ($dateSelect.find('option[value!=""]').length > 0){
                $dateSelect.find('option[value=""]').remove();
            }

            var target = '';
            if (initDate && $dateSelect.find('option[value="' + initDate + '"]').length > 0){
                target = initDate;
            } else {
                target = $dateSelect.find('option[value!=""]').first().val() || '';
            }

            $dateSelect.val(target);
            if (currentMode !== 'batch'){
                $dateSelect.attr('disabled', 'disabled');
            }
            loadBatches(target, initBatchNo);
        }, currentType);
    }

    function loadBatches(billingDate, defaultBatchNo){
        formObj.find('.js-batchCount').text('');
        $batchSelect.empty().attr('disabled', 'disabled');

        if (!billingDate){
            batchSeq++;
            batchesLoading = false;
            $batchSelect.append('<option value="">' + escapeHtml(txt.noBatches) + '</option>');
            highlightRecent();
            scheduleCount();
            return;
        }

        batchesLoading = true;
        var seq = ++batchSeq;
        $('#InvoiceBatch_ID_spinner').customShow();

        getBillingExportBatches({
            date: billingDate,
            BillingCentre_ID: billingCentreID(),
            invoiceType: currentType,
            onSuccess: function(result){
                if (seq !== batchSeq){
                    return;
                }
                batchesLoading = false;
                $('#InvoiceBatch_ID_spinner').customHide();

                var batches = $.isArray(result) ? result : [];
                $batchSelect.empty();

                if (batches.length < 1){
                    $batchSelect.append('<option value="">' + escapeHtml(txt.noBatches) + '</option>');
                } else {
                    $.each(batches, (index, item) =>{
                        var batch = lowerKeys(item);
                        var timeMatch = /Time:(\d{1,2}:\d{2})/.exec(batch.description || '');
                        var range = invoiceRangeText(batch.invoicestart, batch.invoiceend);
                        var rangeLabel = range ? txt.nos + ' ' + range : '#' + batch.batchno;
                        var label = timeMatch ? timeMatch[1] + '  -  ' : '';
                        label += rangeLabel;
                        $batchSelect.append(
                            '<option value="' + escapeHtml(batch.batchno) + '"' +
                                ' data-range="' + escapeHtml(rangeLabel) + '">' +
                                escapeHtml(label) +
                            '</option>',
                        );
                    });

                    var wanted = String(defaultBatchNo || '');
                    if (wanted.length > 0 && $batchSelect.find('option[value="' + wanted + '"]').length > 0){
                        $batchSelect.val(wanted);
                    } else {
                        $batchSelect.val($batchSelect.find('option').first().val());
                    }

                    formObj.find('.js-batchCount').text(
                        batches.length === 1 ? txt.batchesSingle : batches.length + ' ' + txt.batchesMany,
                    );

                    if (currentMode === 'batch'){
                        $batchSelect.removeAttr('disabled');
                    }
                }

                highlightRecent();
                scheduleCount();
            },
        });
    }

    ////////////////////
    //  Recent batches + stats
    ////////////////////

    function invoiceRangeHTML(range){
        return '<span class="ir-recent__nos" title="' + escapeHtml(txt.invoiceNumbers) + '">' +
            (EQLAPP.MYDOWNLOADS.INVOICE_ICON || '') + escapeHtml(range) + '</span>';
    }

    var RECENT_PAGE_SIZE = 4;
    var RECENT_BATCH_MAX = 50;
    var recentBatchLimit = RECENT_PAGE_SIZE;
    var recentBatchSeq = 0;

    function loadRecentBatches(showMore){
        return;

        // wip disabled
        var $list = formObj.find('.js-recentBatches');
        var $more = formObj.find('.js-moreBatches');

        recentBatchLimit = showMore ? recentBatchLimit + RECENT_PAGE_SIZE : RECENT_PAGE_SIZE;
        $more.addClass('is-busy');
        var seq = ++recentBatchSeq;

        // One extra row tells us whether there is more to load
        $.ajax({
            type: 'GET',
            url: '/components/billing.cfc?method=getRecentInvoiceBatches',
            data: {
                billingCentreID: billingCentreID(),
                invoiceType: currentType,
                limit: Math.min(recentBatchLimit + 1, RECENT_BATCH_MAX),
                random: gen_random(),
            },
            dataType: 'JSON',
            cache: false,
            success: function(result){
                if (seq !== recentBatchSeq){
                    return;
                }
                var rows = $.isArray(result) ? result : [];
                var hasMore = rows.length > recentBatchLimit;
                $list.empty();
                $more.removeClass('is-busy').toggleClass('hide', !hasMore);

                if (rows.length < 1){
                    $list.append('<li class="ir-muted">' + escapeHtml(txt.noRecent) + '</li>');
                    return;
                }

                $.each(rows.slice(0, recentBatchLimit), (index, item) =>{
                    var row = lowerKeys(item);
                    var range = invoiceRangeText(row.invoicestart, row.invoiceend);
                    $list.append(
                        '<li>' +
                            '<a href="#" class="ir-recent__item js-recentBatch"' +
                                ' data-batch="' + escapeHtml(row.batchno) + '"' +
                                ' data-date="' + escapeHtml(row.invoicedate) + '">' +
                                '<span class="ir-recent__date">' + escapeHtml(row.displaydate) + '</span>' +
                                '<span class="ir-recent__range">' + (range ? invoiceRangeHTML(range) : '') + '</span>' +
                                '<span class="ir-badge">' + escapeHtml(row.invoicecount) + '</span>' +
                            '</a>' +
                        '</li>',
                    );
                });

                highlightRecent();
            },
            error: function(){
                $list.empty().append('<li class="ir-muted">' + escapeHtml(txt.noRecent) + '</li>');
                $more.removeClass('is-busy').addClass('hide');
            },
        });
    }

    var recentReviewPage = 1;

    function loadRecentReviews(showMore){
        var $list = formObj.find('.js-recentReviews');
        var $more = formObj.find('.js-moreReviews');
        if (!$list.length){ return; }

        recentReviewPage = showMore ? recentReviewPage + 1 : 1;
        $more.addClass('is-busy');

        EQLAPP.MYDOWNLOADS.fetchReviewJobs({ limit: RECENT_PAGE_SIZE, page: recentReviewPage })
            .done((result) =>{
                var reviews = (result && result.reviews) ? result.reviews : [];
                var shown = (recentReviewPage - 1) * RECENT_PAGE_SIZE + reviews.length;
                if (!showMore){
                    $list.empty();
                }
                $more.removeClass('is-busy').toggleClass('hide', !(result && shown < result.total));

                if (reviews.length < 1){
                    if (!showMore){
                        $list.append('<li class="ir-muted">' + escapeHtml(txt.noRecentReviews) + '</li>');
                    }
                    return;
                }

                $.each(reviews, (index, review) =>{
                    var state = EQLAPP.MYDOWNLOADS.getReviewStatus(review);
                    var range = review.invoiceStart
                        ? invoiceRangeHTML(review.invoiceStart + (review.invoiceEnd !== review.invoiceStart ? '-' + review.invoiceEnd : ''))
                        : escapeHtml(review.invoiceCount);
                    var missing = (review.status === 'Ready' && review.missingEmail > 0)
                        ? '<span class="ir-recent__warn">' + escapeHtml(review.missingEmail + ' ' + txt.reviewMissing) + '</span>' : '';
                    var tag = review.status === 'Ready' ? 'a' : 'span';
                    var href = review.status === 'Ready' ? ' href="' + escapeHtml(review.reviewURL) + '"' : '';
                    var typeTag = review.invoiceType === 'nomination'
                        ? '<span class="ir-tag ir-tag--nomination">' + escapeHtml(txt.nomination) + '</span>' : '';

                    $list.append(
                        '<li>' +
                            '<' + tag + href + ' class="ir-recent__item ir-review">' +
                                '<span class="ir-recent__date">' + escapeHtml(review.createdDisplay) + '</span>' +
                                '<span class="ir-recent__range">' + range + '</span>' +
                                '<span class="ir-review__status ir-review__status--' + state.key + '">' + escapeHtml(state.label) + '</span>' +
                                typeTag +
                                missing +
                            '</' + tag + '>' +
                        '</li>',
                    );
                });
            })
            .fail(() =>{
                if (showMore){
                    recentReviewPage -= 1;
                    $more.removeClass('is-busy');
                    return;
                }
                $list.empty().append('<li class="ir-muted">' + escapeHtml(txt.noRecentReviews) + '</li>');
                $more.removeClass('is-busy').addClass('hide');
            });
    }

    formObj.delegate('.js-moreBatches', 'click', function(event){
        event.preventDefault();
        if (!$(this).hasClass('is-busy')){
            loadRecentBatches(true);
        }
    });

    formObj.delegate('.js-moreReviews', 'click', function(event){
        event.preventDefault();
        if (!$(this).hasClass('is-busy')){
            loadRecentReviews(true);
        }
    });

    function highlightRecent(){
        var selected = (currentMode === 'batch') ? String($batchSelect.val() || '') : '';
        formObj.find('.js-recentBatch').each(function(){
            $(this).toggleClass('is-selected', selected.length > 0 && $(this).attr('data-batch') === selected);
        });
    }

    function loadStats(){
        var type = currentType;
        $.ajax({
            type: 'GET',
            url: '/components/billing.cfc?method=getInvoiceHistoryStats',
            data: {
                stallionOnly: isNomination(),
                billingCentre: billingCentreID() || 1,
                random: gen_random(),
            },
            dataType: 'JSON',
            cache: false,
            success: function(result){
                if (type !== currentType){
                    return;
                }
                var stats = lowerKeys(result);
                formObj.find('.js-lastInvoiceNo').text(stats.lastinvoiceno || '-');
                formObj.find('.js-lastInvoiceDate').text(formatSqlDateForDisplay(stats.lastinvoicedate) || '-');
            },
        });
    }

    ////////////////////
    //  Live match count
    ////////////////////

    function getCriteria(){
        var criteria = {
            invoiceType: currentType,
            billingCentreID: billingCentreID(),
            batchNo: '',
            invoiceNoFrom: '',
            invoiceNoTo: '',
            invoiceDateFrom: '',
            invoiceDateTo: '',
            horse_id: '',
            owner_id: '',
        };

        if (currentMode === 'batch'){
            criteria.batchNo = $batchSelect.val() || '';
        } else {
            criteria.invoiceNoFrom = $.trim($('#invoiceNoFrom').val());
            criteria.invoiceNoTo = $.trim($('#invoiceNoTo').val());
            criteria.invoiceDateFrom = $('#invoiceDateFrom').val();
            criteria.invoiceDateTo = $('#invoiceDateTo').val();
            criteria.horse_id = $('#horse_id').val();
            criteria.owner_id = $('#owner_id').val();
        }

        return criteria;
    }

    function criteriaKey(criteria){
        return $.param(criteria);
    }

    function datesInvalid(criteria){
        return criteria.invoiceDateFrom && criteria.invoiceDateTo && criteria.invoiceDateFrom > criteria.invoiceDateTo;
    }

    function checkCriteria(criteria, onDone, onFail){
        $.ajax({
            type: 'GET',
            url: '/components/billing.cfc?method=checkInvoiceHistory',
            data: {
                invoiceNoFrom: criteria.invoiceNoFrom,
                invoiceNoTo: criteria.invoiceNoTo,
                invoiceDateFrom: criteria.invoiceDateFrom,
                invoiceDateTo: criteria.invoiceDateTo,
                horseIDs: criteria.horse_id,
                ownerIDs: criteria.owner_id,
                billingCentreID: criteria.billingCentreID,
                batchNo: criteria.batchNo,
                keepOnly: criteria.invoiceType !== 'nomination',
                stallionOnly: criteria.invoiceType === 'nomination',
                random: gen_random(),
            },
            dataType: 'JSON',
            cache: false,
            success: function(data){
                var result = lowerKeys(data);
                var check = {
                    key: criteriaKey(criteria),
                    mode: currentMode,
                    totalRecords: parseInt(result.totalrecords, 10) || 0,
                    totalInvoices: parseInt(result.totalinvoices, 10) || 0,
                };
                if (parseInt(result.totalrecords, 10) < 0){
                    onFail();
                    return;
                }
                onDone(check);
            },
            error: function(){
                onFail();
            },
        });
    }

    function isOverLimit(check){
        return check.mode === 'filters' && cfg.maxReprintCount > 0 && check.totalInvoices > cfg.maxReprintCount;
    }

    function renderSummary(state, check){
        var count = '-';
        var label = '';
        var note = '';

        $summary.removeClass('is-warning is-empty is-loading');

        switch (state){
            case 'loading':
                $summary.addClass('is-loading');
                formObj.find('.js-summaryLoader').removeClass('hide');
                return;
            case 'noBatch':
                $summary.addClass('is-empty');
                label = txt.chooseBatch;
                goBlocked = true;
                break;
            case 'badDates':
                $summary.addClass('is-warning');
                count = '!';
                label = txt.badDates;
                goBlocked = true;
                break;
            case 'error':
                label = txt.countError;
                goBlocked = false;
                break;
            default:
                count = check.totalInvoices;
                if (check.totalInvoices < 1){
                    $summary.addClass('is-empty');
                    label = txt.noMatches;
                    note = (check.mode === 'filters') ? txt.noMatchesHint : '';
                    goBlocked = true;
                } else if (isOverLimit(check)){
                    $summary.addClass('is-warning');
                    label = txt.invoicesMatch;
                    note = txt.overLimit + ' ' + cfg.maxReprintCount + '. ' + txt.overLimitHint;
                    goBlocked = true;
                } else {
                    label = (check.totalInvoices === 1) ? txt.invoiceMatches : txt.invoicesMatch;
                    note = (check.mode === 'batch') ? ($batchSelect.find('option:selected').attr('data-range') || '') : '';
                    goBlocked = false;
                }
                break;
        }

        formObj.find('.js-summaryLoader').addClass('hide');
        formObj.find('.js-matchCount').text(count);
        formObj.find('.js-matchLabel').text(label);
        formObj.find('.js-matchNote').text(note);
        refreshGoState();
    }

    function scheduleCount(){
        clearTimeout(countTimer);
        countTimer = setTimeout(runCount, 350);
    }

    function runCount(){
        var criteria = getCriteria();
        var seq = ++countSeq;
        lastCheck = null;

        if (currentMode === 'batch' && batchesLoading){
            renderSummary('loading');
            return;
        }

        if (currentMode === 'batch' && !criteria.batchNo){
            renderSummary('noBatch');
            return;
        }

        if (datesInvalid(criteria)){
            renderSummary('badDates');
            return;
        }

        renderSummary('loading');

        checkCriteria(criteria, (check) =>{
            if (seq !== countSeq){
                return;
            }
            lastCheck = check;
            renderSummary('ok', check);
        }, () =>{
            if (seq !== countSeq){
                return;
            }
            renderSummary('error');
        });
    }

    ////////////////////
    //  Submit
    ////////////////////

    function dispatchOutput(criteria){
        var output = selectedOutput();
        var nomination = (criteria.invoiceType === 'nomination');
        var generatingTitle = nomination ? txt.nominationGeneratingTitle : txt.generatingTitle;

        if (output === 'email'){
            popWin({
                popID: 'popInvoicesGenerating'
                ,title: generatingTitle
                ,modal: true
                ,hideCloseButton: true
                ,closeOnEscape: true
                ,width: 600
                ,noAutoWidth: true
                ,contents: loadingBox({
                    classes: 'popEmailLoading popQueueWait',
                    waitMessage: txt.emailWait,
                }),
            });

            EQLAPP.INVOICEMAIN.enqueueInvoiceReview({
                popID: 'popInvoicesGenerating',
                data: {
                    billingCentreID: criteria.billingCentreID,
                    invoiceNoFrom: criteria.invoiceNoFrom,
                    invoiceNoTo: criteria.invoiceNoTo,
                    invoiceDateFrom: criteria.invoiceDateFrom,
                    invoiceDateTo: criteria.invoiceDateTo,
                    horse_id: criteria.horse_id,
                    owner_id: criteria.owner_id,
                    batchNumber: criteria.batchNo,
                    reportname: $('#reportname').val(),
                    reportFormat: 'email',
                    ownership: formObj.find('[name="ownership"]:checked').val(),
                },
                text: {
                    completeHeading: txt.reviewComplete,
                    completeBody: nomination ? txt.nominationReviewReady : txt.reviewReady,
                    continueLabel: txt.reviewContinue,
                    failedHeading: txt.reviewFailedHeading,
                    failedBody: txt.reviewFailedBody,
                },
            });
            return;
        }

        if (output === 'zip'){
            $('#reportFormat').val('zip');

            EQLAPP.INVOICEMAIN.enqueueInvoiceZip({
                formObj: formObj,
                text: {
                    popTitle: generatingTitle,
                    popWaitMessage: txt.zipWait,
                    heading: nomination ? txt.nominationZipHeading : txt.zipHeading,
                    defaultMessage: txt.zipMessage,
                    goToDownloads: txt.goToDownloads,
                },
            });
            return;
        }

        $('#reportFormat').val('pdf');

        if (!cfg.useBlobPrintReports){
            formObj[0].submit();
            return;
        }

        EQLAPP.INVOICEMAIN.submitPrintOptionsReport({
            formObj: formObj,
            text: {
                waitMessage: txt.reportWait,
                generatingTitle: txt.reportTitle,
                errorMessage: txt.reportError,
            },
        });
    }

    function handleCheckResult(check, criteria){
        renderSummary('ok', check);

        if (check.totalInvoices < 1){
            EQLAPP.STRIPE.showAlert({ title: 'Invoice Check', body: txt.noMatches });
            return;
        }

        if (isOverLimit(check)){
            EQLAPP.STRIPE.showAlert({
                title: 'Invoice Check',
                body: txt.overLimit + ' ' + cfg.maxReprintCount + '. ' + txt.overLimitHint,
            });
            return;
        }

        dispatchOutput(criteria);
    }

    function submitInvoices(){
        if (busy || !formObj.valid()){
            return;
        }

        var criteria = getCriteria();

        if (currentMode === 'batch' && !criteria.batchNo){
            renderSummary('noBatch');
            return;
        }

        if (datesInvalid(criteria)){
            renderSummary('badDates');
            return;
        }

        // A fresh count for these exact filters lets PDF open from the click itself, so popup blockers allow the new tab
        if (lastCheck && lastCheck.key === criteriaKey(criteria) && lastCheck.mode === currentMode){
            handleCheckResult(lastCheck, criteria);
            return;
        }

        busy = true;
        refreshGoState();

        checkCriteria(criteria, (check) =>{
            busy = false;
            lastCheck = check;
            handleCheckResult(check, criteria);
        }, () =>{
            busy = false;
            refreshGoState();
            EQLAPP.STRIPE.showAlert({ title: 'Alert', body: txt.networkError });
        });
    }

    ////////////////////
    //  Events
    ////////////////////

    formObj.find('.js-mode').bind('click', function(event){
        event.preventDefault();
        var mode = $(this).attr('data-mode');
        if (mode !== currentMode){
            setMode(mode, true);
        }
    });

    formObj.find('.js-invoiceType').bind('click change', () =>{
        var type = formObj.find('.js-invoiceType:checked').val();
        if (type && type !== currentType){
            setInvoiceType(type, true);
        }
    });

    formObj.find('[name="invoiceOutput"]').bind('click change', refreshOutput);

    $('#BillingCentreID').bind('change', function(){
        setMiscSetting('billing_run_BillingCentre_ID', $(this).val(), false, true);
        loadStats();
        loadRecentBatches();
        populateDates('', '');
    });

    $dateSelect.bind('change', function(){
        loadBatches($(this).val(), '');
    });

    $batchSelect.bind('change', () =>{
        highlightRecent();
        scheduleCount();
    });

    formObj.delegate('.js-recentBatch', 'click', function(event){
        event.preventDefault();
        var batchNo = $(this).attr('data-batch');
        var billingDate = $(this).attr('data-date');

        if (currentMode !== 'batch'){
            setMode('batch', true);
        }

        if ($dateSelect.find('option[value="' + billingDate + '"]').length < 1){
            $dateSelect.prepend('<option value="' + escapeHtml(billingDate) + '">' + escapeHtml(formatSqlDateForDisplay(billingDate)) + '</option>');
        }
        $dateSelect.val(billingDate);
        loadBatches(billingDate, batchNo);
    });

    formObj.find('.js-datePreset').bind('click', function(event){
        event.preventDefault();
        var today = new Date();
        var from = new Date(today.getFullYear(), today.getMonth(), 1);
        var to = today;

        switch ($(this).attr('data-preset')){
            case 'lastMonth':
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case 'last3Months':
                from = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
                break;
            case 'thisYear':
                from = new Date(today.getFullYear(), 0, 1);
                break;
        }

        $('#invoiceDateFrom_Display').datepicker('setDate', from);
        $('#invoiceDateTo_Display').datepicker('setDate', to);
        $('#invoiceDateFrom').val($.datepicker.formatDate('yy-mm-dd', from));
        $('#invoiceDateTo').val($.datepicker.formatDate('yy-mm-dd', to));
        scheduleCount();
    });

    formObj.find('.js-clearDate').bind('click', function(event){
        event.preventDefault();
        clearDatePicker($(this).attr('data-target'), cfg.formID);
        scheduleCount();
    });

    formObj.find('#invoiceDateFrom_Display, #invoiceDateTo_Display').bind('change', scheduleCount);
    formObj.find('#invoiceNoFrom, #invoiceNoTo').bind('keyup change', scheduleCount);
    formObj.find('#owner_id, #horse_id').bind('change', scheduleCount);

    // Owner and horse search popups set hidden values without firing change
    $(document).bind('dialogclose.invoiceReview', () =>{
        if (currentMode === 'filters'){
            scheduleCount();
        }
    });

    formObj.find('.js-clearOwner').bind('click', (event) =>{
        event.preventDefault();
        clearSelection('owner_name', 'owner_id', 'clear_owner', '');
        scheduleCount();
    });

    formObj.find('.js-clearHorse').bind('click', (event) =>{
        event.preventDefault();
        clearSelection('horse_name', 'horse_id', 'clear_horse', '');
        scheduleCount();
    });

    formObj.find('.js-changeHorse').bind('click', (event) =>{
        event.preventDefault();

        var params = 'clear_btn=clear_horse&exclude_ids=' + document.getElementById('horse_id').value + '&multiselect=true&hideCol_HorseClass=true&hideCol_HorseColour=true&hideCol_HorseSex=true&disableGridFix=true&pedigreeHide=true';

        pop_win(
            'ajax_generic_search.cfm'
            ,'horse'
            ,'horse_id,horse_name'
            ,''
            ,''
            ,true
            ,params
            ,''
            ,'Horse Select'
            ,600
            ,'',
        );
    });

    formObj.find('.js-changeOwner').bind('click', (event) =>{
        event.preventDefault();

        var params = 'clear_btn=clear_owner&default_cbox=defaultOwner&gender=M&exclude_ids=' + document.getElementById('owner_id').value + '&multiselect=true&hideCol_countryName=true&disableGridFix=true';

        pop_win(
            'ajax_generic_search.cfm'
            ,'owner'
            ,'owner_id,owner_name'
            ,''
            ,''
            ,true
            ,params
            ,''
            ,'Owner Select'
            ,600
            ,'',
        );
    });

    $go.bind('click', (event) =>{
        event.preventDefault();
        submitInvoices();
    });

    // Enter key in a text field
    formObj.bind('submit', (event) =>{
        event.preventDefault();
        submitInvoices();
    });

    ////////////////////
    //  Validation
    ////////////////////

    formObj.validate({
        rules: {
            invoiceNoFrom: { number: true },
            invoiceNoTo: { number: true },
        },
        messages: {
            invoiceNoFrom: { number: 'Please enter a valid number.' },
            invoiceNoTo: { number: 'Please enter a valid number.' },
        },
    });

    ////////////////////
    //  On Load
    ////////////////////

    applyInvoiceType();
    refreshOutput();
    setMode(currentMode, false);
    loadStats();
    loadRecentBatches();
    loadRecentReviews();
    populateDates(cfg.initBillingDate, cfg.initBatchNo);

}

function getText() {
    return {
        modeHintBatch: $.i18n('IR_MODE_HINT_BATCH'),
        modeHintFilters: $.i18n('IR_MODE_HINT_FILTERS'),
        outputPdf: $.i18n('IR_OUTPUT_PDF'),
        outputEmail: $.i18n('IR_OUTPUT_EMAIL'),
        outputZip: $.i18n('IR_OUTPUT_ZIP'),
        outputZipByOwner: $.i18n('IR_OUTPUT_ZIP_BY_OWNER'),
        buttonPdf: $.i18n('IR_GENERATE_PDF'),
        buttonEmail: $.i18n('IR_PREPARE_FOR_EMAIL'),
        buttonZip: $.i18n('IR_CREATE_ZIP'),
        batchesSingle: $.i18n('IR_ONE_BATCH'),
        batchesMany: $.i18n('IR_BATCHES'),
        noBatches: $.i18n('IR_NO_BATCHES_ON_DATE'),
        nos: $.i18n('IR_NOS'),
        invoiceNumbers: $.i18n('IR_INVOICE_NUMBERS'),
        noRecent: $.i18n('IR_NO_BATCHES_YET'),
        invoiceMatches: $.i18n('IR_INVOICE_MATCHED'),
        invoicesMatch: $.i18n('IR_INVOICES_MATCHED'),
        chooseBatch: $.i18n('IR_CHOOSE_A_BATCH'),
        noMatches: $.i18n('IR_NO_MATCHING_INVOICES'),
        noMatchesHint: $.i18n('IR_NO_MATCHES_HINT'),
        overLimit: $.i18n('IR_ABOVE_THE_LIMIT_OF'),
        overLimitHint: $.i18n('IR_NARROW_FILTERS_HINT'),
        badDates: $.i18n('IR_BAD_DATES'),
        countError: $.i18n('IR_COUNT_ERROR'),
        networkError: $.i18n('IR_NETWORK_ERROR'),
        generatingTitle: $.i18n('IR_GENERATING_INVOICES'),
        emailWait: '<span class="popQueueWait__title">' + $.i18n('IR_PREPARING_YOUR_INVOICES') + '</span>' +
            '<span class="popQueueWait__body">' + $.i18n('IR_EMAIL_WAIT_BODY') + '</span>' +
            '<span class="popQueueWait__note">' + $.i18n('IR_EMAIL_WAIT_NOTE') + '</span>',
        zipWait: $.i18n('IR_INVOICES_BEING_GENERATED') + '<br>' + $.i18n('IR_PLEASE_WAIT_DOTS'),
        zipHeading: $.i18n('IR_ZIP_HEADING'),
        zipMessage: $.i18n('IR_ZIP_MESSAGE'),
        goToDownloads: $.i18n('IR_GO_TO_DOWNLOADS'),
        noRecentReviews: $.i18n('IR_NO_INVOICE_REVIEWS_YET'),
        reviewMissing: $.i18n('IR_MISSING_EMAIL'),
        reportWait: $.i18n('IR_GENERATING_REPORT_WAIT') + '<br>' + $.i18n('IR_PLEASE_WAIT_DOTS'),
        reportTitle: $.i18n('IR_GENERATING_REPORT'),
        reportError: $.i18n('IR_REPORT_ERROR'),
        reviewComplete: $.i18n('IR_COMPLETE'),
        reviewReady: $.i18n('IR_REVIEW_READY'),
        reviewContinue: $.i18n('IR_CONTINUE'),
        reviewFailedHeading: $.i18n('IR_REVIEW_FAILED_HEADING'),
        reviewFailedBody: $.i18n('IR_REVIEW_FAILED_BODY'),
        nomination: $.i18n('IR_NOMINATION'),
        nominationGeneratingTitle: $.i18n('IR_GENERATING_NOMINATION_INVOICES'),
        nominationZipHeading: $.i18n('IR_NOMINATION_ZIP_HEADING'),
        nominationReviewReady: $.i18n('IR_NOMINATION_REVIEW_READY'),
    };
}
